import React from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { useState, useEffect, Fragment } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Card from 'react-bootstrap/Card';
import UserDetails from './UserManagement/userdetails';
import RuleSetManagement from './RuleSetManagement/rule-set-management';
import RolesAndRights from './RolesandRights/roles-and-rights';
import ClientConfigurationAccordion from './ClientConfiguration/client-configuration-accordion';
import { TypeAnimation } from 'react-type-animation';
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from 'react-router-dom';


const Admin = () => {
  const [userRights] = useState(JSON.parse(localStorage.getItem("UserRights")));
  const [rolesAndRights] = useState(JSON.parse(localStorage.getItem("RolesAndRights")));
  const [key, setKey] = useState('usermanagement');
  const navigate = useNavigate();


  const renderTabTitle = (tabKey, title) => {
    if (key === tabKey) {
      return (
        <span className="fixed-tab-title">
          <TypeAnimation
            sequence={[title]}
            speed={40}
            wrapper="span"
            cursor={false}
            repeat={0}
            key={key}
          />
        </span>
      );
    }
    return <span className="fixed-tab-title">{title}</span>;
  };


  const hasRightsToClientConfiguration = () => {

    if (rolesAndRights !== null) {

      let rightID = rolesAndRights.AllRights.find(el => el.RightType.trim() == "CLIENT_CONFIGURATION")?.RightId;

      if (userRights.some(el => el.RightId == rightID)) {

        return userRights.find(el => el.RightId == rightID).RightValue == 1 ? true : false;

      }

    }

  }



  const hasRightsToRolesAndRights = () => {

    if (rolesAndRights !== null) {

      let rightID = rolesAndRights.AllRights.find(el => el.RightType.trim() == "ROLES_AND_RIGHTS")?.RightId;

      if (userRights.some(el => el.RightId == rightID)) {

        return userRights.find(el => el.RightId == rightID).RightValue == 1 ? true : false;

      }

    }

  }



  const hasRightsToUserManagement = () => {

    if (rolesAndRights !== null) {

      let rightID = rolesAndRights.AllRights.find(el => el.RightType.trim() == "USER_MANAGEMENT")?.RightId;

      if (userRights.some(el => el.RightId == rightID)) {

        return userRights.find(el => el.RightId == rightID).RightValue == 1 ? true : false;

      }

    }

  }



  const hasRightsToRuleSetManagement = () => {

    if (rolesAndRights !== null) {

      let rightID = rolesAndRights.AllRights.find(el => el.RightType.trim() == "RULE_SET_MANAGEMENT")?.RightId;

      if (userRights.some(el => el.RightId == rightID)) {

        return userRights.find(el => el.RightId == rightID).RightValue == 1 ? true : false;

      }

    }

  }


  useEffect(() => {
    document.body.classList.add('no-scroll');
    return () => document.body.classList.remove('no-scroll');
  }, []);
  return (
    <Fragment>
      <Header />
      <Container fluid>
        <Row>
          <Col sm={12} className='admin admin-pagescroll'>
            <Card>

              <Card.Body>
                <Tabs
                  id="controlled-tab-example"
                  activeKey={key}
                  onSelect={(k) => setKey(k)}

                >
                  {hasRightsToUserManagement() && (<Tab eventKey="usermanagement" title={renderTabTitle('usermanagement', 'User Management')}>
                    <UserDetails />
                  </Tab>)}
                  {hasRightsToClientConfiguration() && (<Tab eventKey="clientconfiguration" title={renderTabTitle('clientconfiguration', 'Client Configuration')}>
                    { /*<ClientConfigurationAccordion />*/}
                  </Tab>)}
                  {hasRightsToRuleSetManagement() && (<Tab eventKey="rulesetmanagement" title={renderTabTitle('rulesetmanagement', 'Rule Set Management')}>
                    <RuleSetManagement />
                  </Tab>)}
                  {hasRightsToRolesAndRights() && (<Tab eventKey="rolesandrights" title={renderTabTitle('rolesandrights', 'Roles and Rights')}>
                    <RolesAndRights />
                  </Tab>)}
                </Tabs>
              </Card.Body>
            </Card>

          </Col>
        </Row>
      </Container>

      <Footer />
    </Fragment>
  );
};

export default Admin;